import { ROLES } from '../../_config/roles';
import { 
    findAllDepartures, 
    findClientDepartures, 
    findAllDateGroupDepartures, 
    findAllDateGroupClientDepartures, 
    despathDateOrdersClientByMonthAndYear,
    despathDateOrdersGroupByClientAndDate,
    excelDespathDateOrdersClientByMonthAndYear,
    despathDateOrdersClientBySellerMonthAndYear,
    excelDespathDateOrdersClientBySellerMonthAndYear
} from '../../_services/departures.service';
import { getRol } from '../../_utils/storage_handler';

export const findAllDeparturesEvent = async () => {
    let res = await findAllDepartures();
    if(! res.ok){
        throw new Error(res.error);
    }
    return res;
}

export const findAllClientDeparturesEvent = async (cod_client) => {
    let res = await findClientDepartures(cod_client);
    if(! res.ok){
        throw new Error(res.error);
    }
    return res;
}

export const findAllDateGroupDeparturesEvent = async () => {
    let res = await findAllDateGroupDepartures();
    if(! res.ok){
        throw new Error(res.error);
    }
    return res;
}

export const findAllDateGroupClientDeparturesEvent = async () => {
    let res = await findAllDateGroupClientDepartures();
    if(! res.ok){
        throw new Error(res.error);
    }
    return res;
}

export const despathDateOrdersClientByMonthAndYearEvent = async (month, year) => {
    let res = getRol() === ROLES.seller ? await despathDateOrdersClientBySellerMonthAndYear(month, year) : await despathDateOrdersClientByMonthAndYear(month, year);
    if(! res.ok){
        throw new Error(res.error);
    }
    return res;
}

export const excelDespathDateOrdersClientByMonthAndYearEvent = async (month, year) => {
    let res = getRol() === ROLES.seller ? await excelDespathDateOrdersClientBySellerMonthAndYear(month, year) : await excelDespathDateOrdersClientByMonthAndYear(month, year);
    if(! res.ok){
        throw new Error(res.error);
    }
    return res;
}

export const despathDateOrdersGroupByClientAndDateEvent = async (date, client) => {
    let res = await despathDateOrdersGroupByClientAndDate(date, client);
    if(! res.ok){
        throw new Error(res.error);
    }
    return res;
}